import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled, { useTheme } from 'styled-components'
import colors from '../../configuration/colors'
import Modal from '../mini/Modal'
import FlexAlignCenter from '../styled/FlexAlignCenter'
import { H3, P2 } from '../styled/typography/typography'
import useLexicon from '../../hooks/useLexicon'
import { Loader } from '../buttons/SubmitButton'

const Alert = styled.div`
  text-align: center;
  font-size: 13px;
`

const AlertWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  color: #000;
  background: ${props => props.theme.cardBackground};
`

const CancelButton = styled.button`
  border: none;
  box-shadow: none !important;

  &:hover {
    border: none;
    box-shadow: none !important;
  }
`

const DropQuest = ({ onCancel, onDropQuest, text = 'quest' }) => {
  const theme = useTheme()
  const lexicon = useLexicon()
  const [isLoading, setIsLoading] = useState(false)
  const processedText = text
    .replace('quest', lexicon.quest)
    .replace('activity', lexicon.activity)
    .toLowerCase()

  return (
    <Modal width={500} top={50} autoHeight>
      <Alert>
        <AlertWrapper>
          <div
            style={{
              padding: '30px'
            }}
          >
            <H3 as="h3" style={{ marginTop: '20px' }}>
              Are you sure you want to drop this {processedText}?
            </H3>
            <P2 as="p">All progress made in this {processedText} will be lost.</P2>
          </div>
          <FlexAlignCenter
            style={{
              justifyContent: 'flex-end',
              width: '100%',
              padding: '20px',
              borderTop: theme.engagementColumnBorder
            }}
          >
            <CancelButton className={`quest-btn btn-c btn-c-${theme.style}`} onClick={onCancel}>
              Cancel
            </CancelButton>
            <button
              className={`quest-btn btn-d btn-d-${theme.style}`}
              style={{
                marginLeft: '10px',
                paddingLeft: '25px',
                paddingRight: '25px',
                textTransform: 'capitalize',
                position: 'relative'
              }}
              onClick={() => {
                setIsLoading(true)
                onDropQuest()
              }}
              disabled={isLoading}
            >
              <span style={{ visibility: isLoading ? 'hidden' : 'visible' }}>
                Drop {text
                  .replace('quest', lexicon.quest)
                  .replace('activity', lexicon.activity)
                  }
              </span>
              <Loader className={isLoading ? '' : 'hide'} />
            </button>
          </FlexAlignCenter>
        </AlertWrapper>
      </Alert>
    </Modal>
  )
}

DropQuest.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onDropQuest: PropTypes.func.isRequired
}

export default DropQuest
